import { create } from "zustand";
import { BookingService } from "../services/booking.service";
import { useUserAuthStore } from "./useUserAuthStore";

export const useBookingsStore = create((set, get) => ({
  bookings: [],
  loading: false,
  error: null,

  /* =========================
     Fetch bookings
     ========================= */
  fetchBookings: async () => {
    set({ loading: true, error: null });

    try {
      const { currentUser } = useUserAuthStore.getState();
      const isAdmin = currentUser?.role === "admin";

      const data = await BookingService.getAll();

      // Driver sees only own bookings
      const visible = isAdmin
        ? data
        : data.filter((b) => b.userId === currentUser.id);

      set({ bookings: visible, loading: false });
    } catch (err) {
      set({ error: err.message, loading: false });
    }
  },

  /* =========================
     Create booking
     ========================= */
  createBooking: async (payload) => {
    const booking = await BookingService.create(payload);
    set((s) => ({ bookings: [booking, ...s.bookings] }));
  },

  /* =========================
     Cancel booking
     ========================= */
  cancelBooking: async (id) => {
    await BookingService.cancel(id);
    set((s) => ({
      bookings: s.bookings.map((b) =>
        b.id === id ? { ...b, status: "cancelled" } : b
      ),
    }));
  },

  /* =========================
     Admin actions
     ========================= */
  approveBooking: async (id) => {
    const booking = await BookingService.approve(id);
    set((s) => ({
      bookings: s.bookings.map((b) =>
        b.id === id ? booking : b
      ),
    }));
  },

  rejectBooking: async (id, reason) => {
    const booking = await BookingService.reject(id, reason);
    set((s) => ({
      bookings: s.bookings.map((b) =>
        b.id === id ? booking : b
      ),
    }));
  },

  checkoutBooking: async (id, payload) => {
    const booking = await BookingService.checkout(id, payload);
    set((s) => ({
      bookings: s.bookings.map((b) =>
        b.id === id ? booking : b
      ),
    }));
  },

  returnBooking: async (id, payload) => {
    const booking = await BookingService.returnVehicle(id, payload);
    set((s) => ({
      bookings: s.bookings.map((b) =>
        b.id === id ? booking : b
      ),
    }));
  },
}));
